import { render, staticRenderFns } from "./ExpandableSection.vue?vue&type=template&id=55b6fcb1"
import script from "./ExpandableSection.vue?vue&type=script&lang=js"
export * from "./ExpandableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports